(() => {
  const button = document.querySelector('.pra-whatsapp-float');
  const footerDivider = document.querySelector('.pra-v2-footer__bottom');
  if (!button || !footerDivider) return;

  let updateFrame = 0;

  function updateFooterClearance() {
    updateFrame = 0;
    const dividerRect = footerDivider.getBoundingClientRect();
    const dividerIsVisible = dividerRect.top < window.innerHeight && dividerRect.bottom > 0;

    if (!dividerIsVisible) {
      button.classList.remove('pra-whatsapp-float--footer-visible');
      button.style.removeProperty('--pra-whatsapp-footer-offset');
      button.style.removeProperty('bottom');
      return;
    }

    const defaultOffset = window.matchMedia('(max-width: 749px)').matches ? 14 : 20;
    const footerOffset = Math.max(defaultOffset, window.innerHeight - dividerRect.top + 10);
    button.style.setProperty('--pra-whatsapp-footer-offset', `${footerOffset}px`);
    if (button.classList.contains('pra-whatsapp-float--bottom-right') || button.classList.contains('pra-whatsapp-float--bottom-left')) {
      button.style.setProperty('bottom', `${footerOffset}px`, 'important');
    }
    button.classList.add('pra-whatsapp-float--footer-visible');
  }

  function scheduleFooterClearance() {
    if (updateFrame) return;
    updateFrame = window.requestAnimationFrame(updateFooterClearance);
  }

  window.addEventListener('scroll', scheduleFooterClearance, { passive: true });
  window.addEventListener('resize', scheduleFooterClearance);
  updateFooterClearance();
})();
